import React from 'react';

const Icon = ({
  size = 18,
  stroke = 'currentColor',
  strokeWidth = 1.6,
  children,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {children}
  </svg>
);

export const IconBell = (p) => (
  <Icon {...p}>
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9z" />
    <path d="M10 21a2 2 0 0 0 4 0" />
  </Icon>
);
export const IconUser = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-7 8-7s8 3 8 7" />
  </Icon>
);
export const IconCar = (p) => (
  <Icon {...p}>
    <path d="M5 17h14M3 17v-4l3-6h12l3 6v4M7 17v2M17 17v2" />
    <circle cx="8" cy="13.5" r="1.2" fill="currentColor" />
    <circle cx="16" cy="13.5" r="1.2" fill="currentColor" />
  </Icon>
);
export const IconWallet = (p) => (
  <Icon {...p}>
    <path d="M3 7h15a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7z" />
    <path d="M3 7c0-1.7 1.3-3 3-3h11" />
    <circle cx="17" cy="13.5" r="1.4" fill="currentColor" />
  </Icon>
);
export const IconChat = (p) => (
  <Icon {...p}>
    <path d="M4 5h16v11H8l-4 4V5z" />
  </Icon>
);
export const IconLock = (p) => (
  <Icon {...p}>
    <rect x="5" y="11" width="14" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </Icon>
);
export const IconShield = (p) => (
  <Icon {...p}>
    <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" />
    <path d="M9 12l2 2 4-4" />
  </Icon>
);
export const IconKey = (p) => (
  <Icon {...p}>
    <circle cx="8" cy="14" r="4" />
    <path d="M11 13l9-9M16 8l3 3" />
  </Icon>
);
export const IconMail = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 7 9-7" />
  </Icon>
);
export const IconPhone = (p) => (
  <Icon {...p}>
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A15 15 0 0 1 3 6a2 2 0 0 1 2-2z" />
  </Icon>
);
export const IconStar = (p) => (
  <Icon {...p}>
    <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3z" />
  </Icon>
);
export const IconID = (p) => (
  <Icon {...p}>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <circle cx="9" cy="12" r="2.2" />
    <path d="M14 10h4M14 14h4M5 17c.6-1.7 2.2-2.6 4-2.6s3.4.9 4 2.6" />
  </Icon>
);
export const IconLogout = (p) => (
  <Icon {...p}>
    <path d="M14 5h4a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4M14 12H4M8 8l-4 4 4 4" />
  </Icon>
);
export const IconEdit = (p) => (
  <Icon {...p}>
    <path d="M4 20h4l11-11-4-4L4 16v4z" />
    <path d="M14 6l4 4" />
  </Icon>
);
export const IconDownload = (p) => (
  <Icon {...p}>
    <path d="M12 4v12M7 11l5 5 5-5M5 20h14" />
  </Icon>
);
export const IconPlus = (p) => (
  <Icon {...p}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
);
export const IconCheck = (p) => (
  <Icon {...p}>
    <path d="M5 12l5 5 9-10" />
  </Icon>
);
export const IconRoute = (p) => (
  <Icon {...p}>
    <circle cx="6" cy="6" r="2.5" />
    <circle cx="18" cy="18" r="2.5" />
    <path d="M8 6h6a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4H10a4 4 0 0 0-4 4v0" />
  </Icon>
);
export const IconReceipt = (p) => (
  <Icon {...p}>
    <path d="M5 3h14v18l-3-2-2 2-2-2-2 2-2-2-3 2V3z" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </Icon>
);
export const IconSparkle = (p) => (
  <Icon {...p}>
    <path d="M12 3l1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7L12 3z" />
  </Icon>
);
export const IconSend = (p) => (
  <Icon {...p}>
    <path d="M4 12l16-8-6 18-3-7-7-3z" />
  </Icon>
);
export const IconWrench = (p) => (
  <Icon {...p}>
    <path d="M14.7 6.3a4 4 0 0 0 5 5L21 13l-8 8-4-4 8-8-1.3-2.7z" />
    <path d="M9 13l-5 5 2 2 5-5" />
  </Icon>
);
export const IconMapPin = (p) => (
  <Icon {...p}>
    <path d="M12 22s7-7 7-13a7 7 0 0 0-14 0c0 6 7 13 7 13z" />
    <circle cx="12" cy="9" r="2.5" />
  </Icon>
);
export const IconClose = (p) => (
  <Icon {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Icon>
);
export const IconTicket = (p) => (
  <Icon {...p}>
    <path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4V8z" />
    <path d="M11 6v12" strokeDasharray="2 2" />
  </Icon>
);
export const IconArrowR = (p) => (
  <Icon {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </Icon>
);
